import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Typography,
  Divider,
  Descriptions,
  Button,
  Skeleton,
  notification,
} from 'antd';
import dayjs from 'dayjs';

import CustomButton from '../../components/CustomButton';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import MESSAGES from '../../enums/Messages';

import {
  getAdjustInfo as AnnouncementRol,
  notify,
} from '../../api/module/announcement_contractor';

import './style.scss';
import { getLocalStorage } from '../../utils/helpers/helpers';

const { Title, Paragraph } = Typography;

const AnnouncementAdjustInformation = ({ history, match }) => {
  const [personType] = useState(getLocalStorage('person_type'));
  const [personID] = useState(getLocalStorage('tercero'));
  const [announcementRol, setAnnouncementRol] = useState(null);
  const [stageDataEmail, setStageDataEmail] = useState(null);
  const [stage] = useState(parseInt(match.params.stage));
  const [loading, setLoading] = useState(true);
  const [loadingNotification, setLoadingNotification] = useState(false);

  const breadcrumbItems = [
    {
      text: 'Convocatorias para ajustar información',
    },
  ];

  useEffect(() => {
    getAnnouncementRol();
  }, []);

  const getAnnouncementRol = async () => {
    try {
      const { data: responseData } = await AnnouncementRol(
        match.params.announcement_rol_id,
      );
      setAnnouncementRol(responseData);
      setStageDataEmail(responseData.correos);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const notifyUser = async () => {
    setLoadingNotification(true);
    try {
      await notify(match.params.announcement_rol_id, stage);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
      setTimeout(() => {
        setLoadingNotification(false);
        history.push(`/`);
      }, MESSAGES.TIME);
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        duration: 2,
      });
      setLoadingNotification(false);
    }
  };

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title>Convocatorias para ajustar información</Title>
      <Skeleton loading={loading} active>
        {announcementRol && (
          <Descriptions column={2} bordered>
            <Descriptions.Item
              key={`announcement-rol-1`}
              label="Número de convocatoria"
            >
              {announcementRol.convocatoria_numero}
            </Descriptions.Item>
            <Descriptions.Item
              key={`announcement-rol-2`}
              label="Nombre de convocatoria"
            >
              {announcementRol.convocatoria_nombre}
            </Descriptions.Item>
            <Descriptions.Item key={`announcement-rol-3`} label="Organización">
              {announcementRol.organizacion_nombre}
            </Descriptions.Item>
            <Descriptions.Item
              key={`announcement-rol-4`}
              label="Proyecto, licitación concurso u otro"
            >
              {announcementRol.nombre_proyecto}
            </Descriptions.Item>
            <Descriptions.Item key={`announcement-rol-5`} label="Cargo/Rol">
              {announcementRol.cargo}
            </Descriptions.Item>
          </Descriptions>
        )}

        <Divider></Divider>

        <Descriptions column={1} bordered layout="vertical">
          <Descriptions.Item key={`announcement-rol-6`} label="Notificación">
            {stageDataEmail &&
              stageDataEmail.map((item, index) => {
                return (
                  <>
                    <Title level={5}>
                      Email No. {index + 1} - Enviado el:{' '}
                      {dayjs(item.created_at).format('DD MMMM YYYY h:mm a')}
                    </Title>
                    <div
                      key={`announcement-rol-1-${index}`}
                      dangerouslySetInnerHTML={{ __html: item.mensaje }}
                    ></div>
                    <Divider></Divider>
                  </>
                );
              })}
          </Descriptions.Item>
        </Descriptions>
        <Divider orientation="left">
          <Title level={4}>Paso No. 1</Title>
        </Divider>
        <br></br>
        <div style={{ textAlign: 'center' }}>
          <Descriptions column={1} layout="vertical" bordered>
            <Descriptions.Item
              key={`announcement-rol-8`}
              labelStyle={{ fontWeight: 'bold' }}
              label={
                <>
                  <Paragraph>
                    Para actualizar/ajustar siga las siguientes indicaciones:
                  </Paragraph>
                  <ul className="steps-list">
                    <li>
                      Hacer clic en el botón "Actualizar información requerida".
                    </li>
                    <li>
                      Se abrirá en una nueva pestaña de su navegador su perfil.
                    </li>
                    <li>
                      En esa nueva pestaña debe actualizar la información que se
                      le solicita.
                    </li>
                    <li>
                      Luego de actualizar y guardar, debe cerrar esa pestaña.
                    </li>
                    <li>Continúe al paso 2</li>
                  </ul>
                </>
              }
            >
              <Button type="primary">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`${personType === '1' ? INTERNAL_LINKS.NATURAL_PERSON : INTERNAL_LINKS.LEGAL_PERSON}/${personID}`}
                >
                  Actualizar información requerida
                </a>
              </Button>
            </Descriptions.Item>
          </Descriptions>
        </div>
        <Divider orientation="left">
          <Title level={4}>Paso No. 2</Title>
        </Divider>
        <Descriptions column={2} bordered>
          <Descriptions.Item
            key={`announcement-rol-9`}
            labelStyle={{ fontWeight: 'bold' }}
            label="Una vez actualizada la información indicada en el paso No. 1, notifique a la organización haciendo clic en el botón 'Notificar ajuste', de lo contrario no será tenido en cuenta"
          >
            <Button
              loading={loadingNotification}
              type="primary"
              onClick={() => {
                notifyUser();
              }}
            >
              Notificar ajuste
            </Button>
          </Descriptions.Item>
        </Descriptions>
      </Skeleton>
      <br></br>
      <br></br>
      <CustomButton type="default" danger text={<Link to="/">Volver</Link>} />
    </>
  );
};

export default AnnouncementAdjustInformation;
